module.exports = __webpack_public_path__ + "img/bitmap.d2e1a4ee.png";